import React, { useState } from "react";
import Card from "../../../components/ui/Card";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import TextArea from "../../../components/ui/TextArea";
import { Save } from "lucide-react";

const SettingsPage = () => {
  const [settings, setSettings] = useState({
    platformName: "Adnaki",
    supportEmail: "support@adnaki.com",
    commissionRate: "15",
    minPayoutAmount: "1000",
    maintenanceMode: false,
    welcomeMessage: "Welcome to Adnaki! Start connecting with your favorite creators.",
  });

  const handleSave = () => {
    alert("Settings saved successfully!");
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-slate-800">Platform Settings</h1>
        <p className="text-slate-500 mt-1">
          Configure platform-wide settings and preferences.
        </p>
      </div>

      {/* General Settings */}
      <Card>
        <h3 className="text-lg font-semibold text-slate-800 mb-4">General Settings</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Platform Name</label>
            <Input
              value={settings.platformName}
              onChange={(e) => setSettings({ ...settings, platformName: e.target.value })}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Support Email</label>
            <Input
              type="email"
              value={settings.supportEmail}
              onChange={(e) => setSettings({ ...settings, supportEmail: e.target.value })}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Welcome Message</label>
            <TextArea
              value={settings.welcomeMessage}
              onChange={(e) => setSettings({ ...settings, welcomeMessage: e.target.value })}
              rows={3}
            />
          </div>
        </div>
      </Card>

      {/* Financial Settings */}
      <Card>
        <h3 className="text-lg font-semibold text-slate-800 mb-4">Financial Settings</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Platform Commission Rate (%)
            </label>
            <Input
              type="number"
              value={settings.commissionRate}
              onChange={(e) => setSettings({ ...settings, commissionRate: e.target.value })}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Minimum Payout Amount (ETB)
            </label>
            <Input
              type="number"
              value={settings.minPayoutAmount}
              onChange={(e) => setSettings({ ...settings, minPayoutAmount: e.target.value })}
            />
          </div>
        </div>
      </Card>

      {/* System Settings */}
      <Card>
        <h3 className="text-lg font-semibold text-slate-800 mb-4">System Settings</h3>
        <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg">
          <div>
            <p className="font-medium text-slate-800">Maintenance Mode</p>
            <p className="text-sm text-slate-500">Temporarily disable public access to the platform</p>
          </div>
          <button
            onClick={() => setSettings({ ...settings, maintenanceMode: !settings.maintenanceMode })}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
              settings.maintenanceMode ? 'bg-red-600' : 'bg-slate-300'
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                settings.maintenanceMode ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
        </div>
      </Card>

      {/* Save Button */}
      <div className="flex justify-end">
        <Button variant="primary" onClick={handleSave}>
          <Save size={16} className="mr-2" />
          Save Settings
        </Button>
      </div>
    </div>
  );
};

export default SettingsPage;
